import React, { Fragment } from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
export const Marquee = () => {
  const {
    lang
  } = useLanguage();
  const items = translations[lang].marquee;
  const MarqueeContent = () => <div className="flex items-center justify-around w-1/2 min-w-max px-4" data-id="element-161">
      {items.map((item, index) => <Fragment key={index} data-id="element-162">
          <span className="font-serif-cormorant italic text-xl md:text-2xl text-[#1a1a1a] px-8 whitespace-nowrap" data-id="element-163">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#c9a96e] flex-shrink-0" data-id="element-164" />
        </Fragment>)}
    </div>;
  return <div className="w-full bg-[#f8f4ef] py-6 overflow-hidden border-b border-[#c9a96e]/20" data-id="element-165">
      <div className="flex w-[200%] animate-marquee" data-id="element-166">
        <MarqueeContent data-id="element-167" />
        <MarqueeContent data-id="element-168" />
      </div>
    </div>;
};